const APIIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8" fill="none">
		<path
			d="M1.33301 4.83268H5.49967M7.99967 7.33268V0.666016H10.4997C10.9417 0.666016 11.3656 0.841611 11.6782 1.15417C11.9907 1.46673 12.1663 1.89065 12.1663 2.33268V3.16602C12.1663 3.60804 11.9907 4.03197 11.6782 4.34453C11.3656 4.65709 10.9417 4.83268 10.4997 4.83268H7.99967M14.6663 0.666016V7.33268M5.49967 7.33268V2.74935C5.49967 2.19681 5.28018 1.66691 4.88948 1.27621C4.49878 0.885509 3.96888 0.666016 3.41634 0.666016C2.86381 0.666016 2.3339 0.885509 1.9432 1.27621C1.5525 1.66691 1.33301 2.19681 1.33301 2.74935V7.33268"
			stroke="var(--black-color)"
			strokeOpacity="0.85"
			strokeWidth="1.25"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default APIIcon;
